import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../../components/contactformaarbic";

function Gettouch({ rtl }) {
  const className = rtl ? "gettouch p-100 rtl-style" : "gettouch  p-100";
  return (
    <div className={className}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <h2>دعونا نتحدث عن مشروعك</h2>
            <p>
              نمكّن المؤسسات العالمية - الأفراد العاملين بمفردهم والشركات
              الناشئة - من إنشاء شركات لتحقيق الميزة التنافسية. تهدف جميع
              استراتيجياتنا الرقمية، بدءًا من منتجات MVP إلى تطوير المنتجات على
              نطاق واسع، إلى تحقيق تفاعل قوي وقيمة تجارية. أهدافنا ورؤيتنا هي ما
              جعلنا ما نحن عليه اليوم - شركة رائدة في تطوير تطبيقات البرمجيات
              المخصصة في الولايات المتحدة ومجلس التعاون الخليجي.
            </p>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ">
            <ContentFrom rtl="rtl" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
